import { DomainModelHelper } from '@digital-platform/shared/domain';
import { InternalStatus } from '../enums/internal-status';
import { WasteProfileStatus } from '../enums/waste-profile-status';
import { GetAllWasteProfile } from '../waste-profiles-domain';

export class GetAllWasteProfilesModel implements GetAllWasteProfile {
  static readonly DEFAULT_CONFIG: GetAllWasteProfile = {
    lastModifiedDate: null,
    lastModifiedBy: null,
    createdBy: null,
    expiryDate: null,
    name: '',
    id: null,
    epaId: '',
    generatorStatus: '',
    generatorName: '',
    facilityName: '',
    pdfLink: '',
    status: WasteProfileStatus.NOT_SUBMITTED,
    internalStatus: InternalStatus.PENDING_CUSTOMER_INFO,
  };
  // meta info

  readonly lastModifiedDate: Date;
  readonly lastModifiedBy: string;
  readonly createdBy: string;
  readonly expiryDate: Date;
  readonly name: string;
  readonly id: string;
  readonly number: string;
  readonly generatorName: string;
  readonly facilityName: string;
  readonly pdfLink: string;
  readonly status: WasteProfileStatus;
  readonly internalStatus: InternalStatus;
  readonly active: boolean;
  readonly epaId: string;
  readonly generatorStatus: string;

  constructor(config?: GetAllWasteProfile) {
    this.lastModifiedDate = config ? config.lastModifiedDate : null;
    this.lastModifiedBy = config
      ? DomainModelHelper.ensureDataIsString(config.lastModifiedBy)
      : null;
    this.createdBy = config ? config.createdBy : null;
    this.expiryDate = config
      ? config.expiryDate
        ? DomainModelHelper.ensureDataIsDate(config.expiryDate)
        : null
      : null;
    this.name = config
      ? DomainModelHelper.ensureDataIsString(config.name)
      : null;
    this.id = config ? DomainModelHelper.ensureDataIsString(config.id) : null;
    this.status = config.status
      ? config.status
      : WasteProfileStatus.NOT_SUBMITTED;
    this.internalStatus = config.internalStatus
      ? config.internalStatus
      : InternalStatus.PENDING_CUSTOMER_INFO;
    this.generatorName = config.generator?.name
      ? DomainModelHelper.ensureDataIsString(config.generator.name)
      : null;
    this.facilityName = config.destination?.name
      ? DomainModelHelper.ensureDataIsString(config.destination.name)
      : null;
    this.pdfLink = config.docusignData?.signingLink
      ? DomainModelHelper.ensureDataIsString(config.docusignData.signingLink)
      : null;
    this.epaId = config.generator?.epaId
      ? DomainModelHelper.ensureDataIsString(config.generator.epaId)
      : '';
    this.generatorStatus = config.generatorStatus
      ? DomainModelHelper.ensureDataIsString(config.generatorStatus)
      : '';
  }
}
